import { Controller } from "@hotwired/stimulus"

// A painted picture on Dropped pictures (dashboard/dropped_pictures/_painted): Find a clean copy and Paint it again
// each open their own window over the page; Esc, the ×, or a click outside it closes it.
export default class extends Controller {
  static targets = ["dialog"]

  open(event) {
    const dialog = this.dialogTargets.find((d) => d.dataset.panel === event.currentTarget.dataset.panel)
    if (!dialog) return
    dialog.showModal()
    dialog.querySelector(".dp-drop:not([hidden]) input[type=text]")?.focus()
  }

  close(event) { event.currentTarget.closest("dialog")?.close() }

  // A click on the dimmed page around the window (the dialog itself, not anything in it).
  backdrop(event) {
    if (event.target !== event.currentTarget) return
    const box = event.currentTarget.getBoundingClientRect()
    const inside = event.clientX >= box.left && event.clientX <= box.right && event.clientY >= box.top && event.clientY <= box.bottom
    if (!inside) event.currentTarget.close()
  }
}
